import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solution-pilar-landing-page',
  templateUrl: './solution-pilar-landing-page.component.html',
  styleUrls: ['./solution-pilar-landing-page.component.scss']
})
export class SolutionPilarLandingPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
